import { useLocation, useParams } from 'react-router-dom';
import { useMemo, useEffect } from 'react';
import { IDeviceCreate, IDevice } from '../../../store/modules/devices/i-devices';
import { useActions } from '../../providers/actions-provider/actions.context';
import { EDIT_DEVICE_PATH } from '../../routing/paths.constants';
import { useStore } from '../../../store';
import { USER_ID } from '../../../store/modules/user/user.constants';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useDeviceDetails = () => {
  const { pathname } = useLocation();
  const {
    devices, currentUser, groups, facilities,
  } = useStore();
  const { devicesActions, facilityActions, userActions } = useActions();
  const { id } = <{ id: string }>useParams();
  const isEdit = pathname.includes(EDIT_DEVICE_PATH);
  const localStorageService = useLocalStorage();
  const device = devices.data.find(((dev) => dev.id === +id));
  const groupsList = useMemo(() => facilities.data.map(
    (facility) => ({ ...facility, group_code: facility.code }),
  ),
  [facilities]);

  useEffect(() => {
    if (currentUser?.loaded) {
      return;
    }

    const userID: number | null = localStorageService.get(USER_ID);

    if (userID) {
      userActions.getCurrentUser(userID);
    }
  }, []);

  useEffect(() => {
    if (!facilities.loaded) {
      facilityActions.getFacilities();
    }
  }, []);

  useEffect(() => {
    if (isEdit && !device) {
      devicesActions.getDevicesList();
    }
  }, []);

  return useMemo(() => ({
    isEdit,
    device,
    loading: devices.loading,
    groupsList,
    title: isEdit ? 'Device Details' : 'New Device',
    onSubmit: isEdit ? (values:IDevice) => {
      devicesActions.editDevice(values);
    } : (values:IDeviceCreate) => {
      devicesActions.createDevice(values);
    },
    initialValues: device || {
      tenant: currentUser.data?.tenant,
      group_code: '',
      name: '',
      description: '',
      status: 'active',
      apikey: '',
      createdTime: 0,
    },
  }), [pathname, device, devices, groups, facilities, currentUser]);
};

export default useDeviceDetails;
